import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
import Value from './Value';
import { Wrapper as QWrapper } from '../questions/styled';

export const Wrapper = styled.div`
  display: flex;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid ${COLORS.outlineGrey};
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0);
  width: 100%;
  margin: 0 auto 20px;
  flex-direction: column;
  transition: 0.3s;

  &:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.07);
  }
`;

export const Head = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 20px 18px;
    width: 100%;
    margin-bottom: -8px;
    background-color: ${({ headingColor }) => headingColor};
    @media(max-width: 1279px) {
        padding: 10px 15px 18px;
    }
    @media (max-width: 530px) {
        padding: 10px 16px 18px;
    }
`;

export const Header = styled.div`
    display: block;
    width: 100%;
    white-space: normal;
`;

export const Title = styled.div`
    display: block;
    font-size: 20px;
    color: ${COLORS.white};
    line-height: 1.33;
    font-family: ${FONTS.regular}, Arial, Helvetica, sans-serif;
    @media(max-width: 1280px) {
        font-size: 16px;
    }
`;

export const Body = styled.div`
    display:block;
    padding: 0 20px;
    background-color: ${COLORS.white};
    width: 100%;
    @media(max-width: 1279px) {
        padding: 0 15px;
    }
    @media (max-width: 530px) {
        padding: 0 16px;
    }
`;

export const Description = styled.div`
    display:flex;
    width: 100%;
    align-items: center;
    padding: 20px 0;
    font-family: ${FONTS.light};
    font-size: 20px;
    color: ${COLORS.black};
    line-height: 1.33;
    white-space: normal;
    border-bottom: 1px solid ${COLORS.grey};
    flex-wrap: wrap;
    @media(max-width: 1280px) {
        font-size: 16px;
    }
`;

export const Options = styled.div`
    display:flex;
    width: 100%;
    padding: 15px 0;
    border-bottom: 1px solid ${COLORS.grey};
    flex-direction: column;
`;

export const Controls = styled.div`
    display:flex;
    padding: 30px 0 25px;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    @media (max-width: 1280px) {
        padding: 25px 0 25px;
    }
`;

export const ButtonBlock = styled.div`
    display:flex;
    align-items: center;
    width: auto;
    flex-wrap: nowrap;
`;

export const PriceBlock = styled.div`
    display:block;
`;

export const Button = styled(StyledButton)`
    width: auto;
    min-width: 100px;
    padding: 10px 15px;
    font-size: 14px;
    @media (min-width: 1024px) and (max-width: 1279px) {
        padding: 10px;
    }
`;

export const Price = styled(Value)`
    margin-top: ${({ valueActionPeriod }) => valueActionPeriod ? '18px' : '0'};
`;


export const PaddingWrapper = styled(QWrapper)`
    padding-top: ${p => p.nonTopPadding ? '0' : '120px'};
    padding-bottom: ${p => p.nonBottomPadding ? '0' : '120px'};
    overflow: hidden;
`;

export const TitleTariff = styled.h1`
    margin: 60px 0 30px;
    font-family: "robotoLight", Arial, Helvetica, sans-serif;
    font-size: 32px;
    line-height: 1.32;
    font-weight: 300;
    color: #000000;
    @media (max-width: 530px) {
        font-size: 24px;
    }    
`;

export const Subtitle = styled.span`
    display:inline-block;
    width: 100%;
    font-size: 24px;
    margin-top: 10px;
    font-family: ${FONTS.regular};
`;
